import {
    filterOnlyMatchingTagId, filterOnlyMatchingBatterTagId,
} from './byParameterValue.js';
import { filterOnlyHavingParameterSet } from './byParameterName.js';
import { buildPitchPlayerFilters, buildPitchScoringFilters, buildPitchTaggingFilters } from './byContext.js';

const buildFiltersForHittingChart = function({
        // tagging context
        batterId, pitchResults, pitchTypes, zones, pitcherIds, pitcherHandedness,
        // scoring context
        outs, balls, strikes, runnersOn,
    }, requireHit
){
    let batterTagId = parseInt(batterId);
    if (batterTagId === 0 || isNaN(batterTagId)){
        throw new TypeError('batterId is required and should contain valid batter tag ID');
    }

    let hittingChartFilters = [];
    const taggingFilters = buildTaggingFiltersForHittingChart({ pitchResults, pitchTypes, zones, pitcherIds, pitcherHandedness });
    if (taggingFilters instanceof Array){
        hittingChartFilters = hittingChartFilters.concat(taggingFilters);
    }

    const scoringFilters = buildPitchScoringFilters({ outs, balls, strikes, runnersOn });
    if (scoringFilters instanceof Array){
        hittingChartFilters = hittingChartFilters.concat(scoringFilters);
    }
    
    let batterIdFilter = [];
    if (requireHit){
        batterIdFilter = filterOnlyMatchingTagId(batterId);
        batterIdFilter.forEach(filter => filter.parameter = ['hit'].concat(filter.parameter));
        batterIdFilter = filterOnlyHavingParameterSet('hit').concat(batterIdFilter);
    }
    else{
        hittingChartFilters = hittingChartFilters.concat(filterOnlyMatchingBatterTagId(batterId));
    }
    
    if (hittingChartFilters.length){
        hittingChartFilters.forEach(filter => filter.parameter = ['pitch'].concat(filter.parameter));
        hittingChartFilters = filterOnlyHavingParameterSet('pitch').concat(hittingChartFilters);
    }

    return batterIdFilter.concat(hittingChartFilters);
};

const buildTaggingFiltersForHittingChart = function({
    pitchResults, pitchTypes, zones, pitcherIds, pitcherHandedness
}){
    let taggingFilters = buildPitchTaggingFilters(
        { pitchResults, pitchTypes, pitchSet: '', zones, pitcherHandedness, batterHandedness: ''}
    );

    taggingFilters = taggingFilters.concat(buildPitchPlayerFilters(pitcherIds, []));

    return taggingFilters;
};

export default buildFiltersForHittingChart;
export {
    buildFiltersForHittingChart, buildTaggingFiltersForHittingChart
};